export default function formatPagePath(path: string): string {
  const [base, query] = path.split("?")

  let formatted = ""

  if (base.slice(0, 1) !== "/") {
    formatted += "/"
  }
  if (base !== "index") {
    formatted += base
  }
  if (base.slice(-1) !== "/" && base !== "index") {
    formatted += "/"
  }
  if (query) {
    formatted += `?${query}`
  }
  return formatted
}
